import { Vue, Prop } from 'vue-property-decorator';
import axios from '@/zenky/api/Http';
import AbstractResource from '@/zenky/resources/AbstractResource';
import ItemResponse from '@/zenky/api/responses/ItemResponse';
import ResourceProxy from '@/zenky/resources/ResourceProxy';

export default class ResourceItem extends Vue {
  @Prop({ type: String, required: true }) readonly itemId!: string;
  @Prop({ type: Object, required: true }) readonly resource!: AbstractResource<any>;
  protected itemIsLoading: boolean = false;
  protected itemNotFound: boolean = false;
  protected item: any = null;
  resourceProxy!: ResourceProxy;
  private loadingQueues: any = {
    resolve: [],
    reject: [],
  };

  created() {
    this.bootstrapComponent();
  }

  bootstrapComponent() {
    this.createResourceProxy();
  }

  protected createResourceProxy() {
    this.resourceProxy = new ResourceProxy(this.resource);
  }

  protected loadItem(id: string | null = null) {
    return new Promise((resolve, reject) => {
      this.loadingQueues.resolve.push(resolve);
      this.loadingQueues.reject.push(reject);

      if (this.itemIsLoading) {
        return;
      }

      this.itemIsLoading = true;
      this.itemNotFound = false;

      const itemId = id || this.itemId;

      axios.get(this.resourceProxy.getShowApiUrl(itemId))
        .then(({ data }: { data: ItemResponse<any>}) => {
          this.setItem(data.data);
          this.resolveQueue('resolve', data.data);
        })
        .catch((err: any) => {
          this.setItemNotFound(err);
          this.resolveQueue('reject', err);
        });
    });
  }

  private resolveQueue(type: string, data: any) {
    this.loadingQueues[type].forEach((resolve: Function) => resolve(data));
    this.loadingQueues[type] = [];
  }

  protected setItem(item: any) {
    this.itemIsLoading = false;
    this.itemNotFound = false;
    this.item = item;
  }

  protected setItemNotFound(err: any) {
    this.itemIsLoading = false;
    this.itemNotFound = true;
    this.item = null;
  }
}
